import * as React from 'react';

import { kebabCase } from 'lodash';

import { TrackedLink } from '@origin-digital/ods-core';

import { DangerousHtml } from '../DangerousHtml';
import { Heading2, Heading4, HeadingLink } from '../Text';
import {
  HelpItemsList,
  HelpSupportContainer,
  StyledHelpItem,
  StyledSvg,
} from './HelpSupport.styles';
import { IHelpSupports } from '../../models/content.interfaces';
import { isEmpty } from 'lodash';

export const HelpItem = ({ headline, bylineHtml, icon, link, target }) => (
  <StyledHelpItem data-id="help-support-item">
    <TrackedLink
      trackingType="CustomLink"
      trackingLabel={kebabCase(headline)}
      href={link}
      target={isEmpty(target) ? '_self' : target}
      data-id={`support-${kebabCase(headline)}`}
    >
      {icon}
      <HeadingLink>{headline}</HeadingLink>
      <Heading4>
        <DangerousHtml html={bylineHtml} />
      </Heading4>
    </TrackedLink>
  </StyledHelpItem>
);

export const HelpSupport = ({ items, mainHeading }: IHelpSupports) => {
  return (
    <HelpSupportContainer data-id="help-support-container">
      <Heading2 data-id="leading">{mainHeading}</Heading2>
      <HelpItemsList>
        {items.map((item) => (
          <HelpItem
            key={item.headline}
            headline={item.headline}
            bylineHtml={item.bylineHtml}
            icon={<StyledSvg html={item.iconSvg} />}
            link={item.buttonUrl}
            target={item.target}
          />
        ))}
      </HelpItemsList>
    </HelpSupportContainer>
  );
};
